import React from "react";
import s from "./Footer.module.scss";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  AuditOutlined,
  FileProtectOutlined,
  GlobalOutlined,
  WhatsAppOutlined,
  FacebookOutlined,
  InstagramOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { height } = useWindowDimensions();
  const contacts = useSelector((state) => state.application.contacts);
  const lang = useSelector((state) => state.application.lang);
  const { t } = useTranslation();

  return (
    <div className={s.footer}>
      <div className={s.wrapper}>
        <div className={s.logo}>
          <div>
            <div className={s.logo_wrapper}>
              <img
                src={
                  lang === "ru" || lang === "ky"
                    ? "/dark_logo.png"
                    : "/akdf_logo(eng).png"
                }
                className={s.footer_logo}
              />
            </div>
            <div className={s.social_networks}>
              {/* <Link to={contacts.whatsapp}>
                <WhatsAppOutlined className={s.icon} />
              </Link> */}
              <Link to={contacts?.instagram}>
                <InstagramOutlined className={s.icon} />
              </Link>
              <Link to={contacts?.facebook}>
                <FacebookOutlined className={s.icon} />
              </Link>
            </div>
          </div>
        </div>
        <div className={s.item}>
          <div className={s.title}>
            {t("contacts").toUpperCase()}
            <div className={s.line}></div>
          </div>
          <div className={s.contacts}>
            {contacts?.phone_first ? (
              <div className={s.phone}>
                <PhoneOutlined className={s.contacts_icon} /> &nbsp;{" "}
                {contacts?.phone_first}
              </div>
            ) : null}
            {contacts?.email ? (
              <div className={s.email}>
                <MailOutlined className={s.contacts_icon} /> &nbsp;{" "}
                <a href={`mailto:${contacts?.email}`}>{contacts?.email}</a>
              </div>
            ) : null}
            <div className={s.address}>
              <EnvironmentOutlined className={s.contacts_icon} />
              &nbsp;&nbsp;&nbsp;{contacts?.address}
            </div>
          </div>
        </div>
        <div className={s.item}>
          <div className={s.title}>{t("usefulLinks").toUpperCase()}</div>
          <div className={s.line}></div>
          <div className={s.contacts}>
            <div className={s.phone}>
              <Link to="/about">
                <HomeOutlined className={s.link_icon} /> &nbsp; {t("aboutUs")}
              </Link>
            </div>
            <div className={s.phone}>
              <Link to="/approvedProjects">
                <FileProtectOutlined /> &nbsp; {t("projects")}
              </Link>
            </div>
            <div className={s.email}>
              <Link to="/tenders">
                <AuditOutlined /> &nbsp; {t("tenders")}
              </Link>
            </div>
            <div className={s.address}>
              <Link to="/news">
                <GlobalOutlined /> &nbsp; {t("news")}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={s.bottom}>© {t("companyNameLowerCase")} </div>
    </div>
  );
};

export default Footer;
